import { useSetToast } from "@app/components/Toast";
import { useUpdateObjective } from "@app/screens/Objectives/data";
import { Textarea } from "@design-system/Inputs/Textarea";
import { GetObjectiveQuery, ResponseStatus } from "@generated/client/graphql";
import { ChangeEvent, type FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { RESOURCE_NAME, keys } from "./i18n";
import { isObjectiveEditable } from "../../services";
import { Box } from "@design-system/Layout/Box";

type ObjectiveActionPlanProps = {
    objective: GetObjectiveQuery["objective"];
};

export const ObjectiveActionPlan: FC<ObjectiveActionPlanProps> = ({
    objective,
}) => {
    const canEditObjective = useMemo(
        () => isObjectiveEditable(objective),
        [objective],
    );
    const [actionPlan, setActionPlan] = useState<string | undefined>(
        objective?.actionPlan || undefined,
    );
    const { mutate } = useUpdateObjective(objective?.id, objective?.entityId);
    const { setToastError } = useSetToast();
    const handleActionPlanSave = () => {
        if (actionPlan !== objective.actionPlan) {
            const newActionPlan = actionPlan || null;
            mutate(
                { id: objective.id, actionPlan: newActionPlan },
                {
                    onSettled: (data) => {
                        if (
                            data?.updateObjective?.status ===
                            ResponseStatus.Error
                        ) {
                            setToastError(
                                `${data.updateObjective.error?.message}`,
                            );
                        }
                    },
                    onError: () => {
                        setToastError(t(keys.update_error));
                    },
                },
            );
        }
    };

    const handleChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
        if (!canEditObjective) return;
        setActionPlan(event.target.value || undefined);
    };
    const { t } = useTranslation(RESOURCE_NAME);

    return (
        <Box
            className={
                !canEditObjective
                    ? "pointer-events-none cursor-not-allowed"
                    : ""
            }
        >
            <Textarea
                value={actionPlan}
                onChange={handleChange}
                onBlur={handleActionPlanSave}
                cols={6}
            />
        </Box>
    );
};
